import { Box, Typography } from '@mui/material';
import { ReactNode, useMemo } from 'react';
import { StandardJourneyBrandedScreen } from '~/components/StandardJourney';
import PaymentConfirmExitDialog from '~/pages/PaymentConfirm/components/PaymentConfirmExitDialog';
import { ContractExitGuardContext, leaveContractJourney, useContractExitGuard } from '../contractExitGuard';

type ContractJourneyShellProps = {
  appId: string;
  progressPercent: number;
  onBack?: () => void;
  /** `true` quando o «Voltar» sai do fluxo do contrato (passo 1): passa pelo aviso antes de navegar. */
  backLeavesJourney?: boolean;
  /** Saída de «Salvar e sair» → «Sair mesmo assim». Padrão: site institucional (`CONTRACT_EXIT_URL`). */
  onLeave?: () => void;
  children: ReactNode;
};

export default function ContractJourneyShell({
  appId,
  progressPercent,
  onBack,
  backLeavesJourney = false,
  onLeave = leaveContractJourney,
  children
}: ContractJourneyShellProps) {
  const { open, requestExit, stay, confirmExit } = useContractExitGuard(onLeave);
  const guardValue = useMemo(() => ({ requestExit }), [requestExit]);
  const handleBack = onBack && backLeavesJourney ? () => requestExit(onBack) : onBack;

  return (
    <ContractExitGuardContext.Provider value={guardValue}>
      <StandardJourneyBrandedScreen
        appId={appId}
        checkoutActiveStep={2}
        contentLayout="checkout"
        onBack={handleBack}
        progressPercent={progressPercent}
        showBack={Boolean(onBack)}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { md: 8, xs: 4 },
            mx: 'auto',
            maxWidth: 699,
            width: '100%'
          }}
        >
          <Typography align="center" sx={{ px: 1 }} variant="h5">
            Preencha os dados do seu contrato para garantir a cobertura do seu equipamento.
          </Typography>
          {children}
        </Box>
        {/* Mesmo aviso da confirmação do pagamento (Figma 1680:7107). */}
        <PaymentConfirmExitDialog
          appId={`${appId}-exit`}
          onClose={stay}
          onConfirmExit={confirmExit}
          onFillContract={stay}
          open={open}
        />
      </StandardJourneyBrandedScreen>
    </ContractExitGuardContext.Provider>
  );
}
